import { createLazyComponent } from '../shared/createLazyComponent';

// Lives here, not beside the other importers in `app/dynamic-import.jsx`, to avoid an
// import cycle — see .claude/context/code-splitting.md.
export const LazyAssistantDataLayer = createLazyComponent(
  () => import('./AssistantDataLayer'),
  'AssistantDataLayer',
  { label: 'Assistant Data Layer', rethrowOnError: true },
);
